import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import { FindLoad, FindSuccessItem, Images, useModal } from 'utils';
import { CreateChancel, CustomizedSwitch, EditWithIcon, InputMain, SimpleTooltip } from 'components';
import { systemItemStyles } from './styles';
import { ConnectOfficeAlly } from './modals/connectOfficeAlly';
import { OfficeAllyGuide } from './guide';
import { httpRequestsOnSuccessActions, systemActions } from 'store';
import { clearHouseTypeEnums, DISCONNECT_INTEGRATION_ACTION_TYPE, EDIT_INTEGRATION_ACTION_TYPE } from './constants';

export const OfficeAlly = () => {
    const { handleSubmit, control, reset } = useForm();
    const [editAlly, setEditAlly] = useState(false);
    const officeAlly = useSelector((state) => state.system.systemIntegrations)?.officeAlly;
    const classes = systemItemStyles();
    const { open, close } = useModal();
    const dispatch = useDispatch();
    const loader = FindLoad(EDIT_INTEGRATION_ACTION_TYPE);
    const success = FindSuccessItem(EDIT_INTEGRATION_ACTION_TYPE);
    const successDisconnect = FindSuccessItem(DISCONNECT_INTEGRATION_ACTION_TYPE);
    const [connect, setConnect] = useState(false);
    const [guideOpen, setGuideOpen] = useState(false);
    const [sftpPollingEnabled, setSftpPollingEnabled] = useState(false);
    const [automationPaymentEnabled, setAutomationPaymentEnabled] = useState(false);
    const [showPassword, setShowPassword] = useState({
        sftpPassword: false,
        soapPassword: false,
    });

    const resetData = ( ) => {
        setConnect(officeAlly?.isActive);
        setSftpPollingEnabled(officeAlly?.sftpPollingEnabled);
        setAutomationPaymentEnabled(!!officeAlly?.automationPaymentEnabled);
        reset({
            sftpUsername: officeAlly?.sftpCredentials?.username,
            sftpPassword: officeAlly?.sftpCredentials?.password,
            // soapPassword: officeAlly?.soapCredentials?.password,
            // soapSenderId: officeAlly?.soapCredentials?.senderId,
            // soapReceiverId: officeAlly?.soapCredentials?.receiverId,
        });
    }

    useEffect(() => {
        if (officeAlly?.id) {
            resetData();
        }
    }, [officeAlly]);

    useEffect(() => {
        if (success) {
            setEditAlly(false);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(EDIT_INTEGRATION_ACTION_TYPE));
        }
        if (successDisconnect) {
            setEditAlly(false);
            reset({});
            dispatch(httpRequestsOnSuccessActions.removeSuccess(successDisconnect));
        }
    }, [success, successDisconnect]);

    const handleCreate = (data) => {
        dispatch(
            systemActions.editIntegration({
                officeAlly: {
                    sftpPollingEnabled: sftpPollingEnabled,
                    automationPaymentEnabled: automationPaymentEnabled,
                    sftpCredentials: {
                        username: data.sftpUsername,
                        password: data.sftpPassword,
                    },
                    // soapCredentials: {
                    //     username: data.sftpUsername,
                    //     password: data?.soapPassword,
                    //     senderId: data?.soapSenderId,
                    //     receiverId: data?.soapReceiverId,
                    // },
                },
                clearinghouseType: clearHouseTypeEnums.OFFICE_ALLY,
            })
        );
    };

    const handleSetCalendarStatus = () => {
        setConnect(!connect);
        dispatch(systemActions.disconnectIntegration(!connect, clearHouseTypeEnums.OFFICE_ALLY));
    };

    const toggleShowPassword = (field) => {
        setShowPassword((prev) => ({ ...prev, [field]: !prev[field] }));
    };

    return (
        <div className="office-ally-box">
            <div className="space-between" style={{ padding: 16 }}>
                <div className={classes.iconAndTitle}>
                    <img src={Images.officeAlly} alt="officeAlly" />
                    <div className="integration-title-block">
                        <p className="integration-title-text">Office Ally</p>
                        {/*{!officeAlly?.id && (*/}
                            <button type="button" className="setup-guide-btn" onClick={() => setGuideOpen(true)}>
                                <img src={Images.setupGuide} alt="setupGuide" />
                                Setup guide
                            </button>
                        {/*)}*/}
                    </div>
                </div>
                {officeAlly?.id ? (
                    <div className={classes.iconAndTitle} style={{ gap: 16, height: 32 }}>
                        {!editAlly && <EditWithIcon handleClick={() => setEditAlly(!editAlly)} />}
                        <SimpleTooltip title={<p>{'Disconnect Office Ally'}</p>} placement="top-start">
                            <CustomizedSwitch checked={connect} handleClick={handleSetCalendarStatus} />
                        </SimpleTooltip>
                    </div>
                ) : (
                    <button onClick={() => open(<ConnectOfficeAlly />)} className={classes.connectBtn}>
                        Connect
                    </button>
                )}
            </div>

            {editAlly && officeAlly?.id && (
                <div className="edit-office-ally-connection">
                    <form onSubmit={handleSubmit(handleCreate)}>
                        <p className="connection-type-title">SFTP Credentials</p>
                        <div style={{ gap: 16, borderBottom: '1px solid #E4E7EC', marginBottom: 20, paddingBottom: 16 }}>
                            <div className="flex-align-center" style={{ gap: 16 }}>
                                <InputMain
                                    label={'SFTP Username*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="sftpUsername"
                                    type="text"
                                    control={control}
                                    placeholder="Enter username"
                                    rules={{
                                        required: 'Username is required.',
                                    }}
                                />
                                <InputMain
                                    label={'SFTP Password*'}
                                    customClass={true}
                                    variant="outlined"
                                    name="sftpPassword"
                                    type="password"
                                    showPassword={showPassword?.sftpPassword}
                                    control={control}
                                    placeholder="Enter password"
                                    rules={{
                                        required: 'SFTP Password is required.',
                                    }}
                                    onClickIconEnd={() => toggleShowPassword('sftpPassword')}
                                />
                            </div>

                            <div className="flex-align-start" style={{ gap: 4 }}>
                                <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                                <p className="files-sftp-folder">
                                    Files in the configured SFTP folder may be processed, moved, archived, or deleted automatically by
                                    TherapyLake.
                                </p>
                                <CustomizedSwitch checked={sftpPollingEnabled} handleClick={() => setSftpPollingEnabled(!sftpPollingEnabled)} />
                            </div>

                            <div className="flex-align-start" style={{ gap: 4, marginTop: 8 }}>
                                <img src={Images.toolInfoIcon} alt="info" style={{ marginTop: 3 }} />
                                <p className="files-sftp-folder">
                                    Automatically create payments from ERA (835) files.
                                </p>
                                <CustomizedSwitch checked={automationPaymentEnabled} handleClick={() => setAutomationPaymentEnabled(!automationPaymentEnabled)} />
                            </div>
                        </div>
                        {/*<p className="connection-type-title">SOAP Credentials</p>*/}
                        {/*<div className="flex-align-center" style={{ gap: 16 }}>*/}
                        {/*    <InputMain*/}
                        {/*        label={'Sender ID'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="soapSenderId"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Sender ID"*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'Receiver ID'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="soapReceiverId"*/}
                        {/*        type="text"*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter Receiver ID"*/}
                        {/*    />*/}
                        {/*    <InputMain*/}
                        {/*        label={'SOAP Password'}*/}
                        {/*        customClass={true}*/}
                        {/*        variant="outlined"*/}
                        {/*        name="soapPassword"*/}
                        {/*        type="password"*/}
                        {/*        showPassword={showPassword?.soapPassword}*/}
                        {/*        control={control}*/}
                        {/*        placeholder="Enter password"*/}
                        {/*        onClickIconEnd={() => toggleShowPassword('soapPassword')}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        <div style={{ marginTop: 12 }}>
                            <CreateChancel
                                justifyContent={'flex-end'}
                                type="submit"
                                loader={!!loader.length}
                                create={'Save'}
                                chancel={'Cancel'}
                                onClose={() => {
                                    resetData()
                                    setEditAlly(false)
                                }}
                                buttonWidth={'100px'}
                            />
                        </div>
                    </form>
                </div>
            )}

            <OfficeAllyGuide open={guideOpen} onClose={() => setGuideOpen(false)} />
        </div>
    );
};
